export default "__VITE_ASSET__3632791a__"